<template>
  <v-row>
    <v-col cols="12" lg="12" md="12" sm="12" xl="12" xs="12">
      <v-data-table
        :headers="memberHeaders"
        :items="memberItems"
        dense
        :items-per-page="15"
        :loading="isLoading"
        :search="search"
      >
        <template
          v-for="(h, i) in memberHeaders"
          v-slot:[`header.${h.value}`]="{ header }"
        >
          <div :key="i">
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ header.text }}</span>
              </template>
              <span
                class="white--text"
                v-if="header.tooltip_text != undefined"
                >{{ header.tooltip_text }}</span
              >
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`no-data`]>
          <v-alert class="gradient-bg2 white--text">No Data Available</v-alert>
        </template>
        <template v-slot:[`item.employee_id`]="{ item }">
          <span v-text="item.employee_id ? item.employee_id : '-'"> </span>
        </template>
        <template v-slot:[`item.user_email_id`]="{ item }">
          <span>
            {{
              item.user_email_id == undefined ||
              item.user_email_id == null ||
              item.user_email_id == "null"
                ? "-"
                : item.user_email_id
            }}
          </span>
        </template>
        <template v-slot:[`item.user_full_contact_number`]="{ item }">
          <span
            v-text="
              item.user_full_contact_number
                ? item.user_full_contact_number
                : '-'
            "
          >
          </span>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" class="gradient-bg2 white--text">
            No records found!
          </v-alert>
        </template>
        <template v-slot:[`item.user_created_on`]="{ item }">
          <span>{{ get_date(item.user_created_on) }}</span>
        </template>
        <template v-slot:[`item.member_app_last_login`]="{ item }">
          <span v-if="item.member_app_last_login != undefined">{{
            get_date2(item.member_app_last_login)
          }}</span>
          <span v-else>-</span>
        </template>
        <template v-slot:[`item.device_type`]="{ item }">
          <v-icon
            class="ml-n2 mr-2"
            medium
            :color="item.device_type == 'ANDROID' ? '#a4c639' : '#555555'"
            v-text="
              item.device_type != undefined || item.device_type != null
                ? item.device_type == 'ANDROID'
                  ? 'mdi-android'
                  : 'mdi-apple'
                : '-'
            "
          ></v-icon>
          <span
            >{{
              item.app_version != undefined || item.app_version != null
                ? item.app_version
                : "-"
            }}
          </span>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import { GetAllMembersByOrganisationId } from "@/graphql/queries.js";

export default {
  props: {
    OrgObj: Object,
    watchsearch: String,
  },
  data: () => ({
    overlay: false,
    search: "",
    isLoading: false,
    memberHeaders: [
      {
        text: "Member Id",
        value: "employee_id",
        sortable: false,
      },
      {
        text: "Member Name",
        value: "user_name",
        sortable: false,
      },
      {
        text: "Email ID",
        value: "user_email_id",
        sortable: false,
      },

      {
        text: "Contact Number",
        value: "user_full_contact_number",
        sortable: false,
      },
      {
        text: "Created On",
        value: "user_created_on",
        sortable: false,
      },
      {
        text: "Last Login",
        value: "member_app_last_login",
        sortable: false,
      },
      {
        text: "DT / AV",
        value: "device_type",
        tooltip_text: "Device Type / App Version",
        sortable: false,
      },
    ],
    memberItems: [],
  }),
  watch: {
    watchsearch(val) {
      this.search = val;
    },
  },
  mounted() {
    this.get_members(this.OrgObj);
  },
  methods: {
    get_date2(date) {
      let a = new Date(date).toLocaleTimeString("en-In", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
      return a.toUpperCase();
    },
    get_date(date) {
      let a = new Date(date * 1000).toLocaleTimeString("en-In", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      return a.split(",")[0].toUpperCase();
    },

    async get_members(item) {
      this.memberItems = [];
      this.isLoading = true;
      this.overlay = true;
      try {
        let result = await API.graphql(
          graphqlOperation(GetAllMembersByOrganisationId, {
            input: {
              organisation_id: item.organisation_id,
            },
          })
        );
        this.memberItems = JSON.parse(
          result.data.GetAllMembersByOrganisationId
        ).data.Items;
        // console.log(this.memberItems, "this.memberItems");
        this.isLoading = false;
        this.overlay = false;
        this.$forceUpdate();
      } catch (err) {
        console.log("error", err);
        this.isLoading = false;
        this.overlay = false;
      }
    },
  },
};
</script>
<style></style>
